'use client';

import { imageActionCardsSection } from '@stereoagency/sanity-schema';
import { ImageActionCardsSection as UIImageActionCardsSection } from '@stereoagency/ui';
import flush from 'just-flush';
import { sanityImageAsProps, linkAsProps } from '@/utils';
import { SimpleBlockContent } from '../sanity/client';

type Props = typeof imageActionCardsSection.schema.imageActionCardsSection;

export function ImageActionCardsSection({
  title,
  subtitle,
  cards
}: Props) {
  if (!cards?.length) {
    return null;
  }

  const cardProps = flush(
    cards.map((card) => {
      if (card.title && card.image) {
        return {
          image: sanityImageAsProps(card.image),
          title: card.title,
          description: card.description ? (
            <SimpleBlockContent value={card.description} />
          ) : null,
          actions: card.actions?.map((action) => ({
            ...action,
            ...linkAsProps(action),
          }))
        };
      }
      return null;
    })
  );

  return (
    <UIImageActionCardsSection
      title={title}
      subtitle={subtitle}
      cards={cardProps}
    />
  );
}
